export const notesMask = {
  usDisplayName: 'userName',
  usImage: 'userImage',
  note: 'content',
  createdAt: 'date',
};
